import { render, staticRenderFns } from "./MilestoneList.vue?vue&type=template&id=6ca2aacb&scoped=true"
import script from "./MilestoneList.vue?vue&type=script&lang=js"
export * from "./MilestoneList.vue?vue&type=script&lang=js"
import style0 from "./MilestoneList.vue?vue&type=style&index=0&id=6ca2aacb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca2aacb",
  null
  
)

export default component.exports